import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const GenerateKeywords = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function GenerateKeywords({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        d='M7.75 13C7.47386 13 7.25 12.7761 7.25 12.5V8.75H3.5C3.22386 8.75 3 8.52614 3 8.25V7.75C3 7.47386 3.22386 7.25 3.5 7.25H7.25V3.5C7.25 3.22386 7.47386 3 7.75 3H8.25C8.52614 3 8.75 3.22386 8.75 3.5V7.25H12.5C12.7761 7.25 13 7.47386 13 7.75V8.25C13 8.52614 12.7761 8.75 12.5 8.75H8.75V12.5C8.75 12.7761 8.52614 13 8.25 13H7.75Z'
        fill={color}
      />
      <path
        d='M20.5 4.5C20.7761 4.5 21 4.27614 21 4V3.5C21 3.22386 20.7761 3 20.5 3H12.5C12.2239 3 12 3.22386 12 3.5V4C12 4.27614 12.2239 4.5 12.5 4.5H20.5Z'
        fill={color}
      />
      <path
        d='M21 8.25C21 8.52614 20.7761 8.75 20.5 8.75H16.5C16.2239 8.75 16 8.52614 16 8.25V7.75C16 7.47386 16.2239 7.25 16.5 7.25H20.5C20.7761 7.25 21 7.47386 21 7.75V8.25Z'
        fill={color}
      />
      <path
        d='M20.5 13C20.7761 13 21 12.7761 21 12.5V12C21 11.7239 20.7761 11.5 20.5 11.5H12.5C12.2239 11.5 12 11.7239 12 12V12.5C12 12.7761 12.2239 13 12.5 13H20.5Z'
        fill={color}
      />
      <path
        d='M21 16.5C21 16.7761 20.7761 17 20.5 17H3.5C3.22386 17 3 16.7761 3 16.5V16C3 15.7239 3.22386 15.5 3.5 15.5H20.5C20.7761 15.5 21 15.7239 21 16V16.5Z'
        fill={color}
      />
      <path
        d='M20.5 21C20.7761 21 21 20.7761 21 20.5V20C21 19.7239 20.7761 19.5 20.5 19.5H3.5C3.22386 19.5 3 19.7239 3 20V20.5C3 20.7761 3.22386 21 3.5 21H20.5Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'generate-keywords-icon-svg'} iconRender={iconRender} {...props} />;
});

export default GenerateKeywords;
